export default __webpack_public_path__ + "static/week1-6ef310e1ca10bdc6153ad66562e3e08a.png";